import BackIcon from "../../../assets/communication/Back.svg";

export const ShuttleBusBookingConfigureSuspensionHeader = (props) => {
  return (
    <div className="shuttle_bus_booking_body">
        <div className="shuttle_bus_booking_addheader" >
          <div className="back-title-group" onClick={(e)=> props.backBtncallback(e)}>
            <img src={BackIcon} className="back-icon" />
            <span className="back-text">Back</span>
          </div>
        </div>
    </div>
  );
};